module.exports = "/_next/static/images/portfolio_groups_illustration-a84d6388c73920892c3e1e6325ff500e.svg";